import { render, staticRenderFns } from "./TreatmentCreateCore.vue?vue&type=template&id=46bedb24&scoped=true&"
import script from "./TreatmentCreateCore.vue?vue&type=script&lang=js&"
export * from "./TreatmentCreateCore.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentCreateCore.vue?vue&type=style&index=0&id=46bedb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bedb24",
  null
  
)

export default component.exports